import { apiCallback } from 'api';

const definition = {
  service: 'slot-orchestration',
  endpoint: 'filed-slot-times',
  verbs: ['get'],
  defaultVersion: '2',
  query: {
    addressId: '${addressId}',
    branchId: '${branchId}',
    fromDate: '${fromDate}',
    size: '${size}',
    slotType: '${slotType}',
  },
};

export const getFiledSlotTimes = apiCallback(definition, 'get');
